import PropTypes from 'prop-types';
import { useState, useCallback, useEffect } from 'react';
// @mui
import {Box, Stack, Dialog, TextField, Typography, InputAdornment, ListItemButton, listItemButtonClasses} from '@mui/material';
import { GET_ALL_COMPANY } from "../../graphql/modules/company.js";
import { useQuery } from "@apollo/react-hooks";
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
// import SearchNotFound from 'src/components/search-not-found';

// ----------------------------------------------------------------------

export default function AddressListDialog({ title = 'Address Book', list, action, open, onClose, selected, onSelect}) {
  const [searchAddress, setSearchAddress] = useState('');
  const [searchText, setSearch] = useState("");
  const [companyName, setCompanyName] = useState("iatos");
  const [results, setResults] = useState(null);
  const { data, loading, error, refetch } = useQuery(GET_ALL_COMPANY, {
    variables: {
      limit: 1000,
      offset: 0,
      searchText: searchAddress,
      companyName: companyName
      },
      fetchPolicy: "cache-and-network",
    });


  useEffect(() => {
      if(data){
        setResults(data?.getAllCompany)
      }
  }, [data])
  const dataFiltered = applyFilter({
    inputData: list,
    query: searchAddress,
  });

  const notFound = !dataFiltered?.length && !!searchAddress;

  const handleSearchAddress = useCallback((event) => {
    setSearchAddress(event.target.value);
  }, []);

  const handleSelectAddress = useCallback(
    (address) => {
      onSelect(address);
      setSearchAddress('');
      onClose();
    },
    [onClose, onSelect]
  );

  const renderList = (
    <Stack
      spacing={0.5}
      sx={{
        p: 0.5,
        maxHeight: 80 * 8,
        overflowX: 'hidden',
      }}
    >
      {results?.results?.map((address) => (
        <Stack
          key={address?._id}
          spacing={0.5}
          component={ListItemButton}
          onClick={() => handleSelectAddress(address)}
          sx={{
            py: 1,
            px: 1.5,
            borderRadius: 1,
            flexDirection: 'column',
            alignItems: 'flex-start',
            [`&.${listItemButtonClasses.selected}`]: {
              bgcolor: 'action.selected',
              '&:hover': {
                bgcolor: 'action.selected',
              },
            },
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="subtitle2">{address?.companyName}</Typography>
          </Stack>

          {address.companyName && (
            <Box sx={{ color: 'primary.main', typography: 'caption' }}>{address.address}</Box>
          )}


          {address.contactNo && (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {address.contactNo}
            </Typography>
          )}
        </Stack>
      ))}
    </Stack>
  );

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: 3, pr: 1.5 }}
      >
        <Typography variant="h6"> {title} </Typography>

        {action && action}
      </Stack>

      <Stack sx={{ p: 2, pt: 0 }}>
        <TextField
          value={searchAddress}
          onChange={handleSearchAddress}
          placeholder="Search..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      {notFound ? (
        renderList
      ) : (
        renderList
      )}
    </Dialog>
  );
}

AddressListDialog.propTypes = {
  action: PropTypes.node,
  list: PropTypes.array,
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
  open: PropTypes.bool,
  selected: PropTypes.func,
  title: PropTypes.string,
};

// ----------------------------------------------------------------------

function applyFilter({ inputData, query }) {
  if (query) {
    return inputData?.filter(
      (address) =>
        address.name.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        address.fullAddress.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        `${address.company}`.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return inputData;
}
